import api, { API_URL } from '../utils/api';

async function downloadFile(endpoint, params) {
  const token = api.getToken();
  const query = new URLSearchParams(Object.entries(params || {}).filter(([, v]) => v !== '' && v != null));
  const response = await fetch(`${API_URL}${endpoint}?${query.toString()}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    let detail = 'Export failed';
    try { detail = (await response.json())?.detail || detail; } catch (_) { /* not JSON */ }
    throw new Error(detail);
  }
  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = disposition.match(/filename=([^;]+)/);
  const filename = match ? match[1].trim() : 'export.txt';
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

const accountingIntegrationsService = {
  listMappings: (provider) => api.get('/api/accounting-integrations/mappings', { params: { provider } }),
  upsertMapping: (data) => api.put('/api/accounting-integrations/mappings', data),
  deleteMapping: (mappingId) => api.delete(`/api/accounting-integrations/mappings/${mappingId}`),

  exportTally: (params) => downloadFile('/api/accounting-integrations/tally/export', params),
  exportQuickBooksDesktop: (params) => downloadFile('/api/accounting-integrations/quickbooks-desktop/export', params),

  exportHistory: (provider, limit = 50) => api.get('/api/accounting-integrations/export-history', { params: { provider, limit } }),

  previewOpeningBalanceImport: (provider, file) => {
    const formData = new FormData();
    formData.append('provider', provider);
    formData.append('file', file);
    return api.post('/api/accounting-integrations/opening-balance/preview', formData);
  },

  confirmOpeningBalanceImport: (provider, asOfDate, file) => {
    const formData = new FormData();
    formData.append('provider', provider);
    formData.append('as_of_date', asOfDate);
    formData.append('file', file);
    return api.post('/api/accounting-integrations/opening-balance/import', formData);
  },

  openingBalanceHistory: () => api.get('/api/accounting-integrations/opening-balance/history'),

  // QuickBooks Online (live, OAuth2) — distinct from exportQuickBooksDesktop above.
  quickbooksStatus: () => api.get('/api/accounting-integrations/quickbooks/status'),
  quickbooksConnect: () => api.get('/api/accounting-integrations/quickbooks/connect'),
  quickbooksSyncChartOfAccounts: () => api.post('/api/accounting-integrations/quickbooks/sync/chart-of-accounts'),
  quickbooksDisconnect: () => api.delete('/api/accounting-integrations/quickbooks/disconnect'),

  // QuickBooks Online journal entry push — the two-way half of the sync.
  // Chart-of-accounts sync above only ever pulls; these push posted
  // journal entries the other way, into QBO.
  quickbooksAccountMappings: () => api.get('/api/accounting-integrations/quickbooks/account-mappings'),
  quickbooksUpsertAccountMapping: (data) => api.put('/api/accounting-integrations/quickbooks/account-mappings', data),
  quickbooksDeleteAccountMapping: (mappingId) => api.delete(`/api/accounting-integrations/quickbooks/account-mappings/${mappingId}`),
  quickbooksPushJournalEntries: (startDate, endDate, onlyNew = true) => api.post(
    '/api/accounting-integrations/quickbooks/sync/journal-entries', {},
    { params: { start_date: startDate, end_date: endDate, only_new: onlyNew } },
  ),
  quickbooksJournalSyncHistory: (limit = 50) => api.get('/api/accounting-integrations/quickbooks/journal-sync-history', { params: { limit } }),
};

export default accountingIntegrationsService;
